<template>
  <div class="table-pad">
    <table class="table-list" cellspacing="0" cellpadding="0">
      <thead>
        <tr>
          <th v-if="mainTitle">{{mainTitle.name}}</th>
          <th v-for="(title, index) in titles" :key="index">{{title.name}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(list, index) in lists" :key="index">
          <td class="table-list-name" v-if="list[mainName]">
            <cell class="table-store" :title="list[mainName]" is-link v-if="list[mainName] !== '合计'" :link="`${url}/${list.store_id}/${date}/${flag}/${isDay}`"></cell>
            <cell class="table-store" :title="list[mainName]" v-else></cell>
          </td>
          <td v-for="(item, index) in keyArray" :key="index">
            <span  v-if="item === 'ins_premiums_total' || item === 'ins_premiums_avg'">{{list[item] | transferPrice}}</span>
            <span v-else-if ="item === 'ins_completed_rate'">{{list[item] | transferRate}}</span>
            <span v-else>{{list[item]}}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import {
  Cell
} from '@lx-frontend/cvux'
export default {
  components: {
    Cell
  },
  props: {
    mainTitle: {
      type: Array,
      default() {
        return {}
      }
    },
    mainName: {
      type: String,
      default: ''
    },
    titles: {
      type: Array,
      default() {
        return []
      }
    },
    lists: {
      type: Array,
      default() {
        return []
      }
    },
    keyArray: {
      type: Array,
      default() {
        return []
      }
    },
    isDay: {
      type: String,
      default: ''
    }, // true -> 每日数据 false -> 每月数据
    date: {
      type: String,
      default: ''
    },
    flag: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    }
  },
  filters: {
    transferPrice(number) {
      number = number || 0
      return (number / 100).toFixed(2)
    },
    transferRate(rate) {
      return (rate * 100).toFixed(2)
    }
  }
}
</script>
<style rel="stylesheet/less" lang="less">
@import "../../stylesheets/modules/data/carData.less";
</style>
